module.exports = __webpack_public_path__ + "media/images/feature-icons/feature-icon-2-96eae1bb46436d950e15f29785471529.svg";